
export class TenantInfo {
    constructor(public readonly id: number, public readonly name: string) { }
}
